export const SIDEBAR_WIDTH = 272;
export const TOPBAR_HEIGHT = 68;

export type NavSection = { label: string; items: NavItem[] };
export type NavItem = {
  label: string;
  href: string;
  icon: string;
  badge?: number;
  /** When set, the item is included in the exported section constant but
   * must be filtered out by the consuming layout unless the named feature
   * flag (src/lib/feature-flags.ts) is enabled — see AppLayout.tsx and
   * DeveloperLayout.tsx (ALL-5039, HW-L9a: "fixture-free page shells behind
   * a feature flag"). */
  flag?: "hot_wallets" | "deferred_pages" | "invoicing";
};

export const ENTERPRISE_WALLET_NAV_SECTIONS: NavSection[] = [
  {
    label: "Platform",
    items: [
      { label: "Home", href: "/home", icon: "Home" },
      { label: "Wallets", href: "/wallets", icon: "Wallet" },
      { label: "Hot Wallets", href: "/hot-wallets", icon: "Flame", flag: "hot_wallets" },
      { label: "Transfers", href: "/transfers", icon: "ArrowUpDown" },
      { label: "Approvals", href: "/approvals", icon: "CheckCircle" },
      { label: "Invoices", href: "/stablecoins/invoices", icon: "FileText", flag: "invoicing" },
    ],
  },
  {
    label: "Treasury",
    items: [{ label: "Treasury", href: "/treasury", icon: "Landmark", flag: "deferred_pages" }],
  },
  {
    label: "Oversight",
    items: [
      { label: "Governance", href: "/governance", icon: "Shield", flag: "deferred_pages" },
      { label: "Monitoring", href: "/monitoring/alerts", icon: "Activity", flag: "deferred_pages" },
      { label: "Reconciliation", href: "/reconciliation/exceptions", icon: "RefreshCw", flag: "deferred_pages" },
      { label: "Provider migration", href: "/reconciliation/provider-migration/connect", icon: "ArrowRightLeft" },
      { label: "Evidence", href: "/evidence", icon: "FileText", flag: "deferred_pages" },
    ],
  },
  {
    label: "Account",
    items: [{ label: "Recovery", href: "/recovery", icon: "KeyRound", flag: "deferred_pages" }],
  },
];

export const DEVELOPER_NAV_SECTIONS: NavSection[] = [
  {
    label: "Developer",
    items: [
      { label: "Overview", href: "/developer", icon: "Code" },
      { label: "API Keys", href: "/developer/api-keys", icon: "KeyRound" },
      { label: "Webhooks", href: "/developer/webhooks", icon: "Webhook" },
      { label: "Hot Wallets", href: "/developer/hot-wallets", icon: "Flame", flag: "hot_wallets" },
    ],
  },
];

export const ADMIN_PORTAL_NAV_SECTIONS: NavSection[] = [
  {
    label: "Deployment",
    items: [{ label: "Deployment", href: "/admin/deployment", icon: "Container" }],
  },
  {
    label: "Organization",
    items: [
      { label: "Users", href: "/admin/users", icon: "Users" },
      // Badge: open requests, filled in by AdminLayout (hidden at 0). Shown only to
      // holders of admin:users:read (specs/access-requests S-13, ALL-5723).
      { label: "Access requests", href: "/admin/access-requests", icon: "Inbox" },
      { label: "Roles", href: "/admin/roles", icon: "UserCog" },
      { label: "Groups", href: "/admin/groups", icon: "Users" },
      { label: "Service Accounts", href: "/admin/service-accounts", icon: "Server" },
      { label: "Audit Trail", href: "/admin/audit-log", icon: "ScrollText" },
    ],
  },
  {
    label: "Security",
    items: [
      { label: "Single sign-on", href: "/admin/sso", icon: "ShieldCheck" },
      { label: "Signer devices", href: "/admin/signer-devices", icon: "ShieldCheck" },
    ],
  },
  {
    label: "Support",
    items: [
      { label: "Trace lookup", href: "/admin/trace-lookup", icon: "FileSearch" },
      { label: "Sign-in diagnostics", href: "/admin/auth-diagnostics", icon: "ShieldCheck" },
    ],
  },
  {
    label: "Configuration",
    items: [
      { label: "Organization", href: "/admin/org", icon: "Building2" },
      { label: "Auth Config", href: "/admin/auth-config", icon: "ShieldCheck" },
      { label: "Services", href: "/admin/services", icon: "Server" },
    ],
  },
];

export const ORG_ENV = "Production";
